import React from 'react'
import SchoolRecordInput from './SchoolRecordInput'

const EducationalBackgroundTable = ({ register, isRead = false }) => {

    return (
        <div>
            <table className='table table-sm table-bordered'>
                <tbody>
                    <tr>
                        <td>
                            <div className='d-flex align-items-center gap-2'>
                                <span>Entrance into Korea Global School in the 1st Term of G10 as of</span>
                                <SchoolRecordInput
                                    register={register}
                                    type={'date'}
                                    name={'educationalBackground.entrance'}
                                    addClass={'w-auto'}
                                    isRead={isRead}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className='d-flex align-items-center gap-2'>
                                <span>Graduated/Attended from KGS International School as of </span>
                                <SchoolRecordInput
                                    register={register}
                                    type={'date'}
                                    name={'educationalBackground.graduated'}
                                    addClass={'w-auto'}
                                    isRead={isRead}
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default EducationalBackgroundTable